export default __webpack_public_path__ + "static/small-icons-light-c5356f955d0b58bdb0f4c72c6ed51836af5e37190098f635a4f1c152865a72f1.png";